module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('TabView', [_c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Personal Details"
          }
        }, [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Full Name")])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('span', {
          staticClass: "p-float-label"
        }, [_c('InputText', {
          attrs: {
            "id": "firstName"
          },
          model: {
            value: (_vm.firstName),
            callback: function($$v) {
              _vm.firstName = (typeof $$v === 'string' ? $$v.trim() : $$v)
            },
            expression: "firstName"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "firstName"
          }
        }, [_vm._v("First Name")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('span', {
          staticClass: "p-float-label"
        }, [_c('InputText', {
          attrs: {
            "id": "middleName"
          },
          model: {
            value: (_vm.middleName),
            callback: function($$v) {
              _vm.middleName = (typeof $$v === 'string' ? $$v.trim() : $$v)
            },
            expression: "middleName"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "middleName"
          }
        }, [_vm._v("Middle Name")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('span', {
          staticClass: "p-float-label"
        }, [_c('InputText', {
          attrs: {
            "id": "lastName"
          },
          model: {
            value: (_vm.lastName),
            callback: function($$v) {
              _vm.lastName = (typeof $$v === 'string' ? $$v.trim() : $$v)
            },
            expression: "lastName"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "lastName"
          }
        }, [_vm._v("Last Name")])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "employeeNumber"
          }
        }, [_vm._v("Employee Id")]), _vm._v(" "), _c('InputText', {
          attrs: {
            "id": "employeeNumber"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "license"
          }
        }, [_vm._v("License Number")]), _vm._v(" "), _c('InputText', {
          attrs: {
            "id": "license"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "expiryDate"
          }
        }, [_vm._v("License Expiry Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
          attrs: {
            "valueType": "format"
          },
          model: {
            value: (_vm.licenseExpiryDate),
            callback: function($$v) {
              _vm.licenseExpiryDate = $$v
            },
            expression: "licenseExpiryDate"
          }
        }) : _c('InputMask', {
          staticClass: "nepali-calendar form-control",
          attrs: {
            "mask": "9999-99-99",
            "type": "text",
            "id": "expiryDate"
          },
          model: {
            value: (_vm.licenseExpiryDate),
            callback: function($$v) {
              _vm.licenseExpiryDate = $$v
            },
            expression: "licenseExpiryDate"
          }
        })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Radiobutton', {
          attrs: {
            "id": "male",
            "value": "Male"
          },
          model: {
            value: (_vm.gender),
            callback: function($$v) {
              _vm.gender = $$v
            },
            expression: "gender"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "male"
          }
        }, [_vm._v("Male")]), _vm._v(" "), _c('Radiobutton', {
          attrs: {
            "id": "female",
            "value": "Female"
          },
          model: {
            value: (_vm.gender),
            callback: function($$v) {
              _vm.gender = $$v
            },
            expression: "gender"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "female"
          }
        }, [_vm._v("Female")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "maritalStatus"
          }
        }, [_vm._v("Marital Status")]), _vm._v(" "), _c('Dropdown', {
          attrs: {
            "options": _vm.maritalList,
            "optionLabel": "name",
            "placeholder": "--Select--",
            "id": "maritalStatus"
          },
          model: {
            value: (_vm.maritalStatus),
            callback: function($$v) {
              _vm.maritalStatus = $$v
            },
            expression: "maritalStatus"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "nationality"
          }
        }, [_vm._v("Nationality")]), _vm._v(" "), _c('Dropdown', {
          attrs: {
            "options": _vm.nationalityList,
            "optionLabel": "name",
            "placeholder": "--Select--",
            "id": "nationality"
          },
          model: {
            value: (_vm.nationality),
            callback: function($$v) {
              _vm.nationality = $$v
            },
            expression: "nationality"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('label', {
          attrs: {
            "for": "dob"
          }
        }, [_vm._v("Date of Birth")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
          attrs: {
            "valueType": "format"
          },
          model: {
            value: (_vm.dateOfBirth),
            callback: function($$v) {
              _vm.dateOfBirth = $$v
            },
            expression: "dateOfBirth"
          }
        }) : _c('InputMask', {
          staticClass: "nepali-calendar form-control",
          attrs: {
            "mask": "9999-99-99",
            "type": "text",
            "id": "dob"
          },
          model: {
            value: (_vm.dateOfBirth),
            callback: function($$v) {
              _vm.dateOfBirth = $$v
            },
            expression: "dateOfBirth"
          }
        })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-1"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": "Save",
            "icon": "pi pi-save"
          }
        })], 1)])]), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Contact"
          }
        }, [_c('ContactDetails')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Emergency Contact"
          }
        }, [_c('emergencyContact')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Dependents"
          }
        }, [_c('dependents')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Immigration"
          }
        }, [_c('immigration')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Job Description"
          }
        }, [_vm._v("\n              Job Description\n            ")]), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Leave Allocation"
          }
        }, [_c('leaveAllocation')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Salary"
          }
        }, [_c('salary')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Report-to"
          }
        }, [_c('reportTo')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Qualifications"
          }
        }, [_c('qualification')], 1), _vm._v(" "), _c('TabPanel', {
          staticClass: "p-mt-2",
          attrs: {
            "header": "Document"
          }
        }, [_c('documentUpload')], 1)], 1)]
      },
      proxy: true
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-067a0237"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/employeeDetails.vue
// module id = 2018
// module chunks = 0